import { SupportedProvider } from './types';

export type TelephonyFormSection = {
  title: string;
  description: string;
  fieldKeys: string[];
  /** Insert provider webhook info box immediately before this field key */
  webhookInfoBeforeKey?: string;
};

const TWILIO_SECTIONS: TelephonyFormSection[] = [
  {
    title: 'General',
    description: 'Connect to Twilio to provision and manage phone numbers for agents within the platform.',
    fieldKeys: ['ssid', 'auth_token']
  },
  {
    title: 'Voice Configuration',
    description: 'Set up voice connection for incoming and outgoing calls.',
    fieldKeys: ['trunk_sid', 'termination_sip_uri', 'termination_username', 'termination_password']
  },
  {
    title: 'SMS Configuration',
    description: 'Set up messaging settings to send SMS notifications and updates.',
    fieldKeys: ['from_number', 'webhook_username', 'webhook_password'],
    webhookInfoBeforeKey: 'webhook_username'
  }
];

const BANDWIDTH_SECTIONS: TelephonyFormSection[] = [
  {
    title: 'General',
    description:
      'Connect to Bandwidth to provision phone numbers for agents within the platform. Bandwidth will also be used for SMS hosting and messaging services.',
    fieldKeys: ['account_id', 'client_id', 'client_secret']
  },
  {
    title: 'SMS Configuration',
    description: 'Set up messaging settings to send SMS notifications and updates.',
    fieldKeys: ['application_id', 'from_number', 'webhook_username', 'webhook_password'],
    webhookInfoBeforeKey: 'webhook_username'
  }
];

export const getTelephonyFormSections = (provider: SupportedProvider): TelephonyFormSection[] | null => {
  if (provider === 'twilio') return TWILIO_SECTIONS;
  if (provider === 'bandwidth') return BANDWIDTH_SECTIONS;
  return null;
};
